---
title: "Armor-piercing questions"
subtitle: "that i've been asked recently"
date: 2026-05-17 20:32
---

Would your behavior change if you believed the probability was 95%?

What do you actually mean when you say that you want this?

If you don't think it'll work, why are you still doing it?

What are you so afraid will happen if you fail?

Do you actually believe you'll be fine, or are you only saying that so you don't have to think about why you're afraid?

Who did you disappoint so badly that you now reject all the praise you get from others?

If you spent six months doing nothing but playing video games and hanging out with friends, would you feel fine, or would it feel like dying a little?

Are you leaving a line of retreat, or giving yourself an excuse to not try?

Do you feel like you have a say in your own happiness?

What would it look like if change was something you moved toward rather than something that happened to you?
